import axios from 'axios';

// Query String Params
export const getQryString = async function(url, params) {
  let res = await axios.get(url, {
    params,
    headers: {
      'Content-Type': 'application/json'
    },
  });
  return res.data;
}

// const interfacePrefix = "/api";
const interfacePrefix = "";

/**
 * 获取后微信签名
 */
 export function getWeixinSign(params) {
  return getQryString(interfacePrefix + '/ovopark-wechat-message/wx/getSignature', params);
}